import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { Funcionalidad } from '../../_models/funcionalidad';
import { NavService } from '../../_services/_nav.service';
import { Router } from '@angular/router';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { Control } from '../../_models/control';
import { ControlService } from '../../_services/control.service';

@Component( {
  selector: 'app-control-listado',
  templateUrl: 'control-listado.component.html'
} )

export class ControlListadoComponent implements OnInit {

  controles: Control[] = [];
  carTabla = true;
  columnas: any[];
  busqueda: string;
  @ViewChild('dt', { static: true }) tabla: Table;
  menu: Funcionalidad = new Funcionalidad();

  constructor( private conControlesServicio: ControlService,
               private navServicio: NavService,
               private router: Router,
               private autServicio: AutenticacionService ) {
  }

  ngOnInit(): void {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/control' );
    if ( mn ) {
      this.menu = mn;
    }

    this.columnas = [
      { field: 'codigo', header: this.navServicio.buscarMensaje( 'CONTROLES.LBL_CODIGO' ), sort: true },
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'CONCEPTOS.LBL_NOMBRE' ), sort: true },
      { field: 'comportamiento', header: this.navServicio.buscarMensaje( 'CONTROLES.LBL_COMPORTAMIENTO' ), sort: true },
      { field: 'url', header: this.navServicio.buscarMensaje( 'CONTROLES.LBL_URL' ), sort: true },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
    this.busqueda = this.navServicio.getSearch( 'control.component' );

    this.conControlesServicio.listado().subscribe( controles => {
      controles.map( ( s: Control ) => {
        s.comportamiento = s.indicadorInterno ? this.navServicio.buscarMensaje( 'CONTROLES.LBL_INTERNO' ) : this.navServicio.buscarMensaje( 'CONTROLES.LBL_EXTERNO' );
      } );
      this.controles = controles;
      this.carTabla = false;
      this.tabla.filterGlobal( this.busqueda, 'contains' );
    } );
  }

  crear() {
    this.router.navigate( [ 'apl/control/agregar' ] );
  }

  editar( control: Control ) {
    this.router.navigate( [ 'apl/control/actualizar/' + control.idControl ] )
  }

  setBusqueda() {
    this.navServicio.setSearch( 'control.component', this.busqueda );
  }
}
